import { FC } from 'react';
import { IModalFormProps } from 'shared/interfaces/IModalForm';
import DialogInfo from 'components/DialogInfo/DialogInfo';
import FormComponent from './FormComponent/FormComponent';

const ModalForm: FC<IModalFormProps> = (props) => {
  return (
    <DialogInfo
      openDialog={props?.openModal}
      handleDialog={props.handleOpenModal}
      title={props.title || 'My Info Forms'}
      customStyles={{ maxWidth: '1000px', height: '95%', maxHeight: 'max-content', overflow: 'auto' }}
      headerIcon={props?.headerIcon}
    >
      <FormComponent {...props} />
    </DialogInfo>
  );
};

export default ModalForm;
